<template>
  <img class="app-icon" :src="bearSrc" alt="">
</template>

<script>
import { eventBus } from '@/services/bus.js'
import services from '@/services/services.js'

export default {
  name: 'portal-bear',
  data () {
    return {
      watchBear: {
        imgs: [],
        index: 0,
        maxIndex: 0,
        animating: false,
        nCharacters: 0
      },
      hideBear: {
        imgs: [],
        index: 0,
        maxIndex: 0,
        animating: false
      },
      bearSrc: require('./images/animation/hide/hide_bear0.png'),
      currentInputField: '',
      bearStatus: 'default',
      hideLoop: null,
      watchLoop: null,
      revealLoop: null
    }
  },
  created: function () {
    this.preloadImgs()
  },
  computed: {
    charIndex: function () {
      return Math.round(this.watchBear.nCharacters / 2.5) + 3
    }
  },
  mounted: function () {
    eventBus.$on('emailInputFocus', this.emailFocus)
    eventBus.$on('emailInputTyping', this.emailTyping)
    eventBus.$on('passwordInputFocus', this.passwordFocus)
    eventBus.$on('passwordInputBlur', this.passwordBlur)
  },
  methods: {
    preloadImgs: function () {
      let failed = [false, false]
      let index = 0
      while (!failed[0] || !failed[1]) {
        if (!failed[0]) {
          try {
            let imgUrl = require(`./images/animation/watch/watch_bear${index}.png`)
            services.preloadImages([imgUrl]).then((img) => {
              this.watchBear.imgs.push(img)
            })
          } catch (e) {
            failed[0] = true
            this.watchBear.maxIndex = index - 1
          }
        }
        if (!failed[1]) {
          try {
            let imgUrl = require(`./images/animation/hide/hide_bear${index}.png`)
            services.preloadImages([imgUrl]).then((img) => {
              this.hideBear.imgs.push(img)
            })
          } catch (e) {
            failed[1] = true
            this.hideBear.maxIndex = index - 1
          }
        }
        index++
      }
    },
    emailFocus: function () {
      if (this.currentInputField === 'email') return
      this.currentInputField = 'email'
      this.watchBear.index = 0
      if (!this.hideBear.animating) this.bearReveal()
    },
    emailTyping: function (nChar) {
      this.currentInputField = 'email'
      this.watchBear.nCharacters = nChar
      this.bearWatch()
    },
    passwordFocus: function () {
      this.currentInputField = 'password'
      this.bearHide()
    },
    passwordBlur: function () {
      this.currentInputField = ''
      this.bearReveal()
    },
    bearWatch: function () {
      if (this.watchBear.index === this.charIndex || this.hideBear.animating) {
        return
      }
      if (this.watchBear.index > this.charIndex) {
        this.watchBear.index--
      } else if (this.watchBear.index < this.charIndex && this.watchBear.index < this.watchBear.maxIndex) {
        this.watchBear.index++
      }
      this.bearSrc = this.watchBear.imgs[this.watchBear.index][0].src

      if (this.watchBear.index >= this.watchBear.maxIndex) return
      this.watchLoop = setTimeout(function () {
        this.bearWatch()
      }.bind(this), 60)
    },
    bearHide: function () {
      if (this.hideBear.index === this.hideBear.maxIndex) {
        this.bearStatus = 'hidden'
        this.hideBear.animating = false
        return
      }
      this.hideBear.animating = true
      if (this.bearStatus === 'default') this.hideBear.index++
      this.bearSrc = this.hideBear.imgs[this.hideBear.index][0].src
      this.hideLoop = setTimeout(function () {
        this.bearHide()
      }.bind(this), 60)
    },
    bearReveal: function () {
      if (this.hideBear.index === 0) {
        this.bearStatus = 'default'
        this.hideBear.animating = false
        if (this.currentInputField === 'email') this.bearWatch()
        return
      }
      this.hideBear.animating = true
      if (this.bearStatus === 'hidden') this.hideBear.index = this.hideBear.index - 1
      this.bearSrc = this.hideBear.imgs[this.hideBear.index][0].src
      this.revealLoop = setTimeout(function () {
        this.bearReveal()
      }.bind(this), 60)
    }
  },
  beforeDestroy: function () {
    clearTimeout(this.watchLoop)
    clearTimeout(this.revealLoop)
    clearTimeout(this.hideLoop)
  }
}
</script>

<style scoped lang="stylus" src="./portal-bear.styl" >



// WEBPACK FOOTER //
// src/components/portal-bear/portal-bear.vue